angular.module('public.security-manager.employee').component('gccsEmployeeProfileApproveResource', {
  template: require('./template.pug'),
  controller: 'EmployeeProfileApproveResourceController',
  bindings: {
    employeeResource: '<'
  }
});
